import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Yousef Ghanem </span>
             from <span className="purple"> Amman, Jordan.</span>
            <br />
            I am a last semester  <span className="purple">Software Engineer</span> student. I contributed to multiple projects by <span className="purple"> Leading, </span> <span className="purple"> Coding, </span><span className="purple"> Designing, </span>  <span className="purple"> Teamworking </span>and I love even doing more!
            <br />
            <br></br>
            Within few months, I will be completing (BCHS) in software engineering at ASU
            University with bunch of soft and hard skills in hand to apply for your company.
            <br />
            <br />
            Apart from coding and designing, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Going out with friends
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring new technologies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Building useful projects
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build projects that will surely make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Yousef Ghanem</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
